export default __webpack_public_path__ + "static/media/dm_loai_dich_vu.06e15651.xlsx";